export default "__VITE_ASSET__BmTbBZjH__"